import Link from 'next/link';
import styled, { css } from 'styled-components';

const BREAKPOINT = 'max-width: 650px';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px auto;
`;

export const Content = styled.nav`
  display: flex;
  flex-direction: row;
  border-top: 1px solid ${(props) => props.theme.textDark};
  border-left: 1px solid ${(props) => props.theme.textDark};
  border-bottom: 1px solid ${(props) => props.theme.textDark};
  border-radius: 5px;
  overflow: hidden;

  @media (${BREAKPOINT}) {
    display: none;
  }
`;

export const MobileWrapper = styled.nav<{ hasPrev: boolean; hasNext: boolean }>`
  display: none;

  @media (${BREAKPOINT}) {
    display: flex;
    flex-direction: row;
    width: 260px;
    justify-content: ${({ hasPrev, hasNext }) => (hasPrev && hasNext ? 'space-between' : 'center')};
  }
`;

export const Item = styled(Link)<{ $active?: boolean; $noHover?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  height: 46px;
  border-right: 1px solid ${(props) => props.theme.textDark};
  font-size: 16px;
  font-weight: bold;
  gap: 10px;

  ${(props) =>
    props.$active
      ? `
      background-color: ${props.theme.textDark};
      color: ${props.theme.background};
    `
      : `
      color: ${props.theme.textDark};
    `}

  ${({ $noHover, theme }) =>
    !$noHover &&
    css`
      &:hover {
        background-color: ${theme.textDark};
        color: ${theme.background};
      }
    `}

  @media (${BREAKPOINT}) {
    width: auto;
    min-width: 120px;
    border: 1px solid ${({ theme }) => theme.textDark};
    border-radius: 5px;
    color: ${({ theme }) => theme.textDark};
  }
`;
